import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { getAccessToken } from "./oktaAuth";

interface ResolveExtensionRequest {
  accountEmail: string;
  taskToken: string;
}

interface AccountLookupResult {
  email: string;
  expires_date?: string;
  expires?: string;
  comment?: string;
}

interface ChangeEmailRequest {
  oldEmail: string;
  newEmail: string;
  comment?: string;
  notify: boolean;
}

interface ChangeEmailResult {
  message: string;
}

const supportApi = createApi({
  reducerPath: "supportApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API_URI,
    prepareHeaders: (headers) => {
      const token = getAccessToken();
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    resolveExtension: builder.mutation<void, ResolveExtensionRequest>({
      query: ({ accountEmail, taskToken }) => ({
        url: "/extensions/resolve",
        method: "POST",
        body: { accountEmail, taskToken },
      }),
    }),
    lookupAccount: builder.query<AccountLookupResult, string>({
      query: (email) => `/accounts/lookup?email=${encodeURIComponent(email)}`,
    }),
    changeEmail: builder.mutation<ChangeEmailResult, ChangeEmailRequest>({
      query: (body) => ({
        url: "/accounts/change-email",
        method: "POST",
        body,
      }),
    }),
  }),
});

const {
  useResolveExtensionMutation,
  useLazyLookupAccountQuery,
  useChangeEmailMutation,
} = supportApi;

export type { AccountLookupResult };

export {
  supportApi,
  useResolveExtensionMutation,
  useLazyLookupAccountQuery,
  useChangeEmailMutation,
};
